import axiosHttp from "./interceptor.service";

const getProjectByToken = ({ token } = {}) => {
  return axiosHttp.get("/feedback/getProjectByTokenId", { params: { token } });
};

const updateProjectResponse = (id, data) => {
  return axiosHttp.put(`/feedback/updateProjectResponse/${id}`, data);
};

export { getProjectByToken, updateProjectResponse };
